export default "__VITE_ASSET__a66feceb__"